import type { ExternalInstallments } from "@app/types/checkout-types";
import type { CreditCardBrand } from "@app/types/napi-types";
import type { PaymentProvider, SpreedlyPayment } from "@app/types/napi-v2";
import type { InstallmentsCharges } from "@app/types/napi-v2-charges-types";

import { PAYMENT_PLATFORMS } from "../constants";

export const formatInstallments = (
  installments: InstallmentsCharges | undefined,
  total_billed_amount: number
): ExternalInstallments | undefined => {
  if (!installments) {
    return undefined;
  }

  return {
    type: "external_plans",
    quantity: installments.installments,
    interest_rate: installments.amount,
    plan_id: installments.id,
    installment_amount:
      installments.installments > 0
        ? total_billed_amount / installments.installments
        : total_billed_amount,
    total_amount: total_billed_amount
  };
};

const isSpreedly = (
  payment_provider: PaymentProvider
): payment_provider is SpreedlyPayment =>
  payment_provider.provider === PAYMENT_PLATFORMS.SPREEDLY;

export const getSpreedlySupportedCreditCards = (
  payment_providers: PaymentProvider[]
): CreditCardBrand[] => {
  return payment_providers.find(isSpreedly)?.supported_credit_cards || [];
};
